var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-autocomplete", {
        staticClass: "chiped-input",
        class: _vm.dense ? "grv-input-dense" : "grv-input",
        attrs: {
          "menu-props": { contentClass: "grv-menu" },
          rules: _vm.rules,
          value: _vm.value,
          clearable: "",
          items: _vm.items,
          loading: _vm.loading,
          name: _vm.param.name,
          "item-text": "name",
          "item-value": "id",
          "search-input": _vm.search,
          multiple: _vm.multiple,
          readonly: _vm.readonly,
          "auto-select-first": "",
          dense: _vm.dense,
          "no-filter": "",
          "hide-no-data": "",
          chips: "",
          "small-chips": _vm.dense,
          "deletable-chips": !_vm.readonly,
          placeholder: "Rechercher un bundle"
        },
        on: {
          "update:error": function($event) {
            _vm.errored = $event
          },
          "update:searchInput": function($event) {
            _vm.search = $event
          },
          "update:search-input": function($event) {
            _vm.search = $event
          },
          change: function($event) {
            return _vm.$emit("update:value", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [_c("Label", { attrs: { param: _vm.param } })]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function(ref) {
              var tile = ref.tile
              var item = ref.item
              return [
                _vm.multiple
                  ? _c(
                      "v-list-tile-avatar",
                      [
                        tile.props.value
                          ? _c("v-icon", { attrs: { color: "primary" } }, [
                              _vm._v("check_box")
                            ])
                          : _c("v-icon", [_vm._v("check_box_outline_blank")])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-list-tile-content",
                  [
                    _c("v-list-tile-title", [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t")
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-list-tile-sub-title",
                      { staticClass: "font-italic caption" },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(item.description) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-list-tile-action", [
                  _vm._v("\n\t\t\t\t#" + _vm._s(item.id) + "\n\t\t\t")
                ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("Hint", { attrs: { param: _vm.param, errored: _vm.errored } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fa20f5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fa20f5a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/bundleid.vue
// module id = null
// module chunks = 